import styled from 'styled-components';

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 14px;

  & label {
    font-size: 13px;
    color: var(--muted);
  }
`;

export const Input = styled.input`
  min-height: 44px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid var(--line);
  background: var(--felt-deep);
  font-size: 16px;
`;

export const ErrorText = styled.p`
  margin: 0 0 12px;
  color: #ff8c80;
`;
